import request from '@/utils/request'

// 获取图形验证码
export const getPicCodeApi = () => {
  return request.get('/passport/getpiccode')
}

// 获取短信验证码
export const getMsgCodeApi = (picCode, picKey, mobile) => {
  return request.post('/passport/sendsmscaptcha', {
    form: {
      captchaCode: picCode,
      captchaKey: picKey,
      mobile
    }
  })
}

// 账号密码登录
export const LoginApi = (account, password) => {
  return request.post('/passport/login', {
    form: {
      account,
      password
    }
  })
}

// 注册（昵称 + 账号 + 密码 + 手机号验证码 或 邮箱验证码）
export const RegisterApi = ({ nickname, account, password, mobile, smsCode, email, emailCode }) => {
  return request.post('/passport/register', {
    form: {
      nickname,
      account,
      password,
      mobile,
      smsCode,
      email,
      emailCode
    }
  })
}

// ============ 邮箱登录/注册（保留兼容，页面不再使用） ============

// 获取邮箱验证码
export const getEmailCodeApi = (picCode, picKey, email) => {
  return request.post('/passport/sendemailcaptcha', {
    form: {
      captchaCode: picCode,
      captchaKey: picKey,
      email
    }
  })
}

// 邮箱验证码登录（未注册自动注册）
export const EmailLoginApi = (email, emailCode) => {
  return request.post('/passport/emaillogin', {
    form: {
      email,
      emailCode
    }
  })
}

// ============ 微信登录（微信内置浏览器网页授权） ============

// 获取微信网页授权登录地址
// redirect: 登录成功后要回跳的前端路径（可选，默认 /home）
export const getWechatLoginUrlApi = (redirect) => {
  return request.post('/passport/wechaturl', {
    form: {
      redirect
    }
  })
}

// 微信授权 code 登录（未注册自动注册）
export const wechatLoginApi = (code, state) => {
  return request.post('/passport/wechatlogin', {
    form: {
      code,
      state
    }
  })
}